// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"141":"methodenfinder","597":"projects","962":"home"}[chunkId] + ".min.js";
};